import type { StyleSystemProps } from '@withjoy/joykit';

export const rootStyles: StyleSystemProps = {
  backgroundColor: 'mono2',
  paddingY: [6, null, 10],
  paddingX: [6, null, 88],

  marginX: [-6, null, 0],
  borderRadius: 'inherit',
};
